// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1216":"0f86914b","5199":"b8c394c4"}[chunkId] + ".chunk.css";
};